import React from "react";

export default function ComingSoon({ title, description, sections }) {
  return (
    <div>
      <h1 className="text-2xl font-bold mb-1" style={{ color: "#154E93" }}>{title}</h1>
      <p className="text-sm text-gray-500 mb-6">{description}</p>

      <div className="bg-white rounded-lg shadow-sm p-6 mb-6 border-l-4" style={{ borderColor: "#F3850C" }}>
        <div className="flex items-center gap-2 mb-1">
          <span className="text-lg">🚧</span>
          <span className="font-semibold" style={{ color: "#154E93" }}>This module isn't built yet</span>
        </div>
        <p className="text-sm text-gray-600">
          Here's what's planned for it. We're building JyBek Home Care Services module by module —
          tell your admin which piece to prioritize next.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {sections.map((section) => (
          <div key={section.heading} className="bg-white rounded-lg shadow-sm p-4">
            <h3 className="font-semibold mb-2" style={{ color: "#154E93" }}>{section.heading}</h3>
            <ul className="text-sm text-gray-600 space-y-1">
              {section.items.map((item) => (
                <li key={item} className="flex items-center gap-2">
                  <span className="text-gray-300">○</span> {item}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
